export default __webpack_public_path__ + "1854ff5ec98a488e6a06c309240ff2c2.svg";